export const CAMERA = 1;
export const GAUGE = 2;
export const IP_CAMERA = 3;